import { render, staticRenderFns } from "./OzDrawerStatic.vue?vue&type=template&id=1038e19d&scoped=true&"
import script from "./OzDrawerStatic.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzDrawerStatic.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzDrawerStatic.vue?vue&type=style&index=0&id=1038e19d&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038e19d",
  null
  
)

export default component.exports